// extracted by mini-css-extract-plugin
export default {"stickyItem":"StickyItem_stickyItem__AW9zN"};